import { useEffect } from 'react';
import {
  useCreateChecklistMutation,
  useCreateChecklistPILMutation,
  useLazyGetChecklistDataQuery,
  useLazyGetChecklistPILDataQuery,
  useUpdateChecklistMutation,
  useUpdateChecklistPILMutation,
  useGetAllSQChecklistsMutation,
  useGetAllPILSQChecklistsMutation,
  usePublishSQChecklistEtmfMutation
} from 'src/services/SqChecklist';
import { useAppDispatch } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';

export const useSqChecklist = () => {
  const dispatch = useAppDispatch();

  const [
    getChecklistData,
    {
      isSuccess: getsqChecklistIsSuccess,
      isError: getsqChecklistIsError,
      data: sqChecklistData,
      error: getsqChecklistError
    }
  ] = useLazyGetChecklistDataQuery();

  const [createSqChecklist, { data: createSqChecklistData, error: createSqChecklistError }] =
    useCreateChecklistMutation();
  const [updateSqChecklist, { data: updateSqChecklistData, error: updateSqChecklistError }] =
    useUpdateChecklistMutation();

  useEffect(() => {
    if (createSqChecklistError || updateSqChecklistError) {
      updateUserAccess(createSqChecklistError || updateSqChecklistError, dispatch);
    }
  }, [createSqChecklistError, updateSqChecklistError]);

  const [
    getSqChecklistPILQueryData,
    {
      isLoading: getSqChecklistPILLoading,
      isSuccess: getsqChecklistPILIsSuccess,
      isError: getSqChecklistPILIsError,
      data: sqChecklistPILData,
      error: getSqChecklistPILError
    }
  ] = useLazyGetChecklistPILDataQuery();

  const [createSqChecklistPIL, { error: createSqChecklistPILError }] = useCreateChecklistPILMutation();
  const [updateSqChecklistPIL, { error: updateSqChecklistPILError }] = useUpdateChecklistPILMutation();
  const [
    getAllSQChecklists,
    {
      data: getAllsqChecklistData,
      error: getAllsqChecklistError,
      isError: getAllsqChecklistIsError,
      isSuccess: getAllsqChecklistIsSuccess
    }
  ] = useGetAllSQChecklistsMutation();
  const [
    getAllPILSQChecklists,
    {
      data: getAllPILsqChecklistData,
      error: getAllPILsqChecklistError,
      isError: getAllPILsqChecklistIsError,
      isSuccess: getAllPILsqChecklistIsSuccess
    }
  ] = useGetAllPILSQChecklistsMutation();

  const [
    publishSQChecklistEtmf,
    {
      isLoading: publishSQChecklistLoading,
      isSuccess: publishSQChecklistSuccess,
      data: publisSQCheckListData,
      isError: publishSQChecklistIsError,
      error: publishSQChecklistError
    }
  ] = usePublishSQChecklistEtmfMutation();

  useEffect(() => {
    if (getSqChecklistPILError || updateSqChecklistPILError || createSqChecklistPILError) {
      updateUserAccess(getSqChecklistPILError || updateSqChecklistPILError || createSqChecklistPILError, dispatch);
    }
  }, [getSqChecklistPILError, updateSqChecklistPILError, createSqChecklistPILError]);

  return {
    sqChecklistData,
    getsqChecklistError,
    getChecklistData,
    getsqChecklistIsSuccess,
    getsqChecklistIsError,
    createSqChecklist,
    createSqChecklistData,
    createSqChecklistError,
    updateSqChecklist,
    updateSqChecklistData,
    sqChecklistPILData,
    getSqChecklistPILError,
    getSqChecklistPILQueryData,
    getsqChecklistPILIsSuccess,
    getSqChecklistPILIsError,
    createSqChecklistPIL,
    updateSqChecklistPIL,
    getSqChecklistPILLoading,
    getAllSQChecklists,
    getAllsqChecklistData,
    getAllsqChecklistError,
    getAllsqChecklistIsError,
    getAllsqChecklistIsSuccess,
    getAllPILSQChecklists,
    getAllPILsqChecklistData,
    getAllPILsqChecklistError,
    getAllPILsqChecklistIsError,
    getAllPILsqChecklistIsSuccess,
    publishSQChecklistEtmf,
    publishSQChecklistLoading,
    publishSQChecklistSuccess,
    publisSQCheckListData,
    publishSQChecklistIsError,
    publishSQChecklistError
  };
};
